import * as React from 'react';
import { Route } from 'react-router-dom';
import { AuthRoute } from '@common/components';
import { DocTitleComponent } from './DocTitle';
import { ErrorBoundary } from '@common/components';

export const TitleRoute = (props: any) => {
  const { component, render, computedMatch, allowedRoles, ...otherProps } = props;
  const Component = component;

  return allowedRoles && allowedRoles.length ? (
    <AuthRoute
      allowedRoles={allowedRoles}
      render={newProps => (
        <DocTitleComponent title={props.title}>
          <ErrorBoundary>
            <Component match={otherProps.match || computedMatch} {...otherProps} history={newProps.history} />
          </ErrorBoundary>
        </DocTitleComponent>
      )}
      {...otherProps}
    />
  ) : (
    <Route
      render={newProps => (
        <DocTitleComponent title={props.title}>
          <ErrorBoundary>
            <Component match={otherProps.match || computedMatch} {...otherProps} history={newProps.history} />
          </ErrorBoundary>
        </DocTitleComponent>
      )}
      {...otherProps}
    />
  );
};



// WEBPACK FOOTER //
// ./src/App/TitleRoute.tsx